export const friendLinks = [
  {
    name: '台南旅遊網',
    url: 'https://www.twtainan.net'
  },
  {
    name: '台南旅遊粉絲團',
    url: 'https://www.facebook.com/traveltainan',
  },
  {
    name: '臺南市政府民政局',
    url: 'https://bca.tainan.gov.tw'
  },
  {
    name: '臺南市文化資產管理處',
    url: 'http://tmach-culture.tainan.gov.tw',
  },
  {
    name: '隱私權政策',
    url: 'https://www.twtainan.net/zh-tw/privacy-policy',
  },
  {
    name: '數位資料使用須知',
    url: 'https://www.twtainan.net/zh-tw/gwoia',
  },
  {
    name: '網站安全政策',
    url: 'https://www.twtainan.net/zh-tw/security-policy',
  },
  {
    name: '聯絡我們',
    url: ' https://www.twtainan.net/zh-tw/contact-us',
  }
]
